'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
var _typeof = require('@babel/runtime/helpers/typeof');
Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = void 0;
var _regenerator = _interopRequireDefault(require('@babel/runtime/regenerator'));
var _asyncToGenerator2 = _interopRequireDefault(require('@babel/runtime/helpers/asyncToGenerator'));
var _slicedToArray2 = _interopRequireDefault(require('@babel/runtime/helpers/slicedToArray'));
var _react = _interopRequireWildcard(require('react'));
var _provider = require('../../provider');
var Styles = _interopRequireWildcard(require('./styles'));
var _jsxRuntime = require('react/jsx-runtime');
function _getRequireWildcardCache(nodeInterop) {
	if (typeof WeakMap !== 'function') return null;
	var cacheBabelInterop = new WeakMap();
	var cacheNodeInterop = new WeakMap();
	return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
		return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	})(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
	if (!nodeInterop && obj && obj.__esModule) {
		return obj;
	}
	if (obj === null || (_typeof(obj) !== 'object' && typeof obj !== 'function')) {
		return { default: obj };
	}
	var cache = _getRequireWildcardCache(nodeInterop);
	if (cache && cache.has(obj)) {
		return cache.get(obj);
	}
	var newObj = {};
	var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	for (var key in obj) {
		if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
			var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
			if (desc && (desc.get || desc.set)) {
				Object.defineProperty(newObj, key, desc);
			} else {
				newObj[key] = obj[key];
			}
		}
	}
	newObj['default'] = obj;
	if (cache) {
		cache.set(obj, newObj);
	}
	return newObj;
}
var WalletSelectModal = function WalletSelectModal(_ref) {
	var inputWallets = _ref.wallets,
		classNameOverrides = _ref.classNameOverrides;
	var _useContext = (0, _react.useContext)(_provider.SeiWalletContext),
		connectedWallet = _useContext.connectedWallet,
		setTargetWallet = _useContext.setTargetWallet,
		wallets = _useContext.wallets,
		connectionError = _useContext.connectionError,
		targetWallet = _useContext.targetWallet,
		setConnectionError = _useContext.setConnectionError,
		showConnectModal = _useContext.showConnectModal,
		setShowConnectModal = _useContext.setShowConnectModal;
	var visibleWallets = inputWallets || wallets || [];
	var _useState = (0, _react.useState)(false),
		_useState2 = (0, _slicedToArray2['default'])(_useState, 2),
		isConnecting = _useState2[0],
		setIsConnecting = _useState2[1];
	var _useState3 = (0, _react.useState)(),
		_useState4 = (0, _slicedToArray2['default'])(_useState3, 2),
		infoTitle = _useState4[0],
		setInfoTitle = _useState4[1];
	var _useState5 = (0, _react.useState)(false),
		_useState6 = (0, _slicedToArray2['default'])(_useState5, 2),
		isMobile = _useState6[0],
		setIsMobile = _useState6[1];
	(0, _react.useEffect)(
		function () {
			if (connectedWallet || connectionError) {
				setIsConnecting(false);
			}
		},
		[connectedWallet, connectionError]
	);
	(0, _react.useEffect)(function () {
		var handleResize = function handleResize() {
			setIsMobile(window.innerWidth < 480);
		};
		setIsMobile(window.innerWidth < 480);
		window.addEventListener('resize', handleResize);
		return function () {
			return window.removeEventListener('resize', handleResize);
		};
	}, []);
	var isWalletInstalled = (0, _react.useMemo)(
		function () {
			if (typeof window === 'undefined') return false;
			return targetWallet !== undefined && window[targetWallet.walletInfo.windowKey] !== undefined;
		},
		[targetWallet]
	);
	var hasImportantInfo = connectionError || infoTitle;
	var closeModal = function closeModal(e) {
		e.stopPropagation();
		if (infoTitle) {
			setInfoTitle(undefined);
			return;
		}
		setConnectionError(undefined);
		setShowConnectModal(false);
	};
	var renderWallet = function renderWallet(wallet) {
		var _targetWallet$walletI;
		var isConnectedWallet = (connectedWallet === null || connectedWallet === void 0 ? void 0 : connectedWallet.walletInfo.name) === wallet.walletInfo.name;
		var renderConnection = function renderConnection() {
			if (isConnectedWallet) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.WalletItemInfoIcon, {});
			return null;
		};
		var selectWallet = /*#__PURE__*/ (function () {
			var _ref2 = (0, _asyncToGenerator2['default'])(
				/*#__PURE__*/ _regenerator['default'].mark(function _callee() {
					return _regenerator['default'].wrap(function _callee$(_context) {
						while (1)
							switch ((_context.prev = _context.next)) {
								case 0:
									setTargetWallet(wallet);
									if (!(connectedWallet === wallet)) {
										_context.next = 3;
										break;
									}
									return _context.abrupt('return');
								case 3:
									setIsConnecting(true);
									setConnectionError(undefined);
								case 5:
								case 'end':
									return _context.stop();
							}
					}, _callee);
				})
			);
			return function selectWallet() {
				return _ref2.apply(this, arguments);
			};
		})();
		var isWalletTargeted =
			(targetWallet === null || targetWallet === void 0 || (_targetWallet$walletI = targetWallet.walletInfo) === null || _targetWallet$walletI === void 0
				? void 0
				: _targetWallet$walletI.windowKey) === wallet.walletInfo.windowKey;
		var CalculatedItemComponent = Styles.WalletItem;
		if (isConnectedWallet) CalculatedItemComponent = Styles.WalletItemConnected;
		if (isWalletTargeted) CalculatedItemComponent = Styles.WalletItemTargeted;
		return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(
			CalculatedItemComponent,
			{
				'data-testid': wallet.walletInfo.windowKey,
				onClick: selectWallet,
				children: [
					/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.WalletItemInfo, {
						children: [
							/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.WalletItemInfoImage, {
								alt: wallet.walletInfo.name,
								src: wallet.walletInfo.icon
							}),
							/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.WalletItemInfoName, {
								children: wallet.walletInfo.name
							})
						]
					}),
					renderConnection()
				]
			},
			wallet.walletInfo.name
		);
	};
	var renderAdditionalInfo = function renderAdditionalInfo() {
		if (isConnecting) {
			return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightCentered, {
				children: [
					/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightConnectingIcon, {
						alt: targetWallet === null || targetWallet === void 0 ? void 0 : targetWallet.walletInfo.icon,
						src: targetWallet === null || targetWallet === void 0 ? void 0 : targetWallet.walletInfo.icon
					}),
					/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightItemTitle, {
						children: ['Connecting to ', targetWallet === null || targetWallet === void 0 ? void 0 : targetWallet.walletInfo.name, '...']
					})
				]
			});
		}
		if (!isWalletInstalled && targetWallet) {
			var _targetWallet$walletI2, _targetWallet$walletI3;
			return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRight, {
				children: [
					/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightHeader, {
						onClick: function onClick() {
							setConnectionError(undefined);
							setTargetWallet(undefined);
						},
						children: [
							/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightIcon, {}),
							/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightTitle, {
								children: [
									(targetWallet === null ||
									targetWallet === void 0 ||
									(_targetWallet$walletI2 = targetWallet.walletInfo) === null ||
									_targetWallet$walletI2 === void 0
										? void 0
										: _targetWallet$walletI2.name) || 'Wallet',
									' not installed'
								]
							})
						]
					}),
					/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightError, {
						children: [
							/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightErrorIcon, {}),
							/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightErrorDescription, {
								children: [
									'Please ensure you open this webpage from within the ',
									(targetWallet === null ||
									targetWallet === void 0 ||
									(_targetWallet$walletI3 = targetWallet.walletInfo) === null ||
									_targetWallet$walletI3 === void 0
										? void 0
										: _targetWallet$walletI3.name) || 'Wallet',
									' mobile app.'
								]
							})
						]
					}),
					(targetWallet === null || targetWallet === void 0 ? void 0 : targetWallet.walletInfo.website) &&
						/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightDownload, {
							target: '_blank',
							href: targetWallet.walletInfo.website,
							children: ['Download ', targetWallet === null || targetWallet === void 0 ? void 0 : targetWallet.walletInfo.name]
						})
				]
			});
		}
		if (connectionError) {
			var _targetWallet$walletI4;
			return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRight, {
				children: [
					/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightHeader, {
						onClick: function onClick() {
							setConnectionError(undefined);
							setTargetWallet(undefined);
						},
						children: [
							/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightIcon, {}),
							/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightTitle, {
								children: 'Connection error'
							})
						]
					}),
					/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightError, {
						children: [
							/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightErrorIcon, {}),
							/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightTitle, {
								children: [
									"We couldn't connect to ",
									(targetWallet === null ||
									targetWallet === void 0 ||
									(_targetWallet$walletI4 = targetWallet.walletInfo) === null ||
									_targetWallet$walletI4 === void 0
										? void 0
										: _targetWallet$walletI4.name) || 'your wallet'
								]
							})
						]
					}),
					/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightItem, {
						children: [
							/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightItemTitle, {
								children: 'How to resolve this issue?'
							}),
							/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightItemDescription, {
								children: 'A pending action or a locked wallet can cause issues. Please open the extension manually and try again.'
							})
						]
					})
				]
			});
		}
		if (connectedWallet && !hasImportantInfo) {
			return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightCentered, {
				children: [
					/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightConnectingIcon, {
						alt: targetWallet === null || targetWallet === void 0 ? void 0 : targetWallet.walletInfo.icon,
						src: targetWallet === null || targetWallet === void 0 ? void 0 : targetWallet.walletInfo.icon
					}),
					/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightItemTitle, {
						children: ['Connected to ', targetWallet === null || targetWallet === void 0 ? void 0 : targetWallet.walletInfo.name]
					})
				]
			});
		}
		if (!hasImportantInfo && isMobile) return null;
		return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRight, {
			children: [
				/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightHeader, {
					onClick: function onClick() {
						return setInfoTitle(undefined);
					},
					children: [
						/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightIcon, {
							onClick: function onClick() {
								return setInfoTitle(undefined);
							}
						}),
						/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightTitle, {
							children: 'New to using a wallet?'
						})
					]
				}),
				/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightItem, {
					children: [
						/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightItemTitle, {
							children: 'A Secure Hub for Digital Transactions'
						}),
						/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightItemDescription, {
							children: 'Wallets provide a secure environment for signing and sending transactions involving your tokens and NFTs.'
						})
					]
				}),
				/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardRightItem, {
					children: [
						/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightItemTitle, {
							children: 'A modern way to log in'
						}),
						/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightItemDescription, {
							children: 'Rather than generating new accounts and passwords for each website, simply link your wallet.'
						})
					]
				})
			]
		});
	};
	if (!showConnectModal) return null;
	var renderContent = function renderContent() {
		var shouldShowHomeInfo = !hasImportantInfo || !isMobile;
		return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
			children: [
				shouldShowHomeInfo &&
					/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardHeader, {
						children: [
							/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardHeaderTitle, {
								children: 'Connect a wallet'
							}),
							/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardHeaderClose, {
								onClick: closeModal
							})
						]
					}),
				/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.CardContent, {
					children: [
						shouldShowHomeInfo &&
							/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
								children: [
									/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardContentWallets, {
										children: visibleWallets.map(renderWallet)
									}),
									/*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardContentSeparator, {})
								]
							}),
						renderAdditionalInfo()
					]
				})
			]
		});
	};
	var renderMobileHelper = function renderMobileHelper() {
		if (hasImportantInfo) return null;
		var title = 'New to using a wallet?';
		return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardContentMobileHelper, {
			children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.CardRightTitle, {
				onClick: function onClick() {
					return setInfoTitle(title);
				},
				children: title
			})
		});
	};
	return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Styles.ModalBackground, {
		'data-testid': 'modal__background',
		className: classNameOverrides === null || classNameOverrides === void 0 ? void 0 : classNameOverrides.background,
		onClick: closeModal,
		children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Styles.ModalCard, {
			className: classNameOverrides === null || classNameOverrides === void 0 ? void 0 : classNameOverrides.card,
			onClick: function onClick(e) {
				return e.stopPropagation();
			},
			children: [renderContent(), renderMobileHelper()]
		})
	});
};
var _default = (exports['default'] = WalletSelectModal);
//# sourceMappingURL=WalletSelectModal.js.map
